module.exports = __webpack_public_path__ + "static/media/7.d5a6080c.JPG";